import { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import { InputProps } from './types';
import { InputToggle } from '../InputToggle/InputToggle';
import { InputLabel } from 'features/common/components/Form/InputLabel';
import { Error } from 'features/common/components/Form/Form.styles';

import { StyledInput, InputContainer, InputDescription } from './Input.styles';

export const Input: FC<InputProps & { isPunchup?: boolean }> = ({
	id,
	name,
	label,
	description,
	isToggle = true,
	isPunchup = false,
	...rest
}) => {
	const {
		register,
		setValue,
		watch,
		formState: { errors },
	} = useFormContext();
	const error = errors[name];

	return (
		<InputContainer hasError={Boolean(error)} isPunchup={isPunchup}>
			{isToggle ? (
				<InputToggle htmlFor={id ?? name} label={label} name={`${name}Enabled`} isPunchup={isPunchup} />
			) : (
				<InputLabel htmlFor={id ?? name} label={label} color={isPunchup ? 'black' : 'white'} />
			)}
			{name === 'name' ? (
				<StyledInput id={id ?? name} {...rest} type="text" {...register(name)} isPunchup={isPunchup} />
			) : (
				<StyledInput
					type="text"
					id={id ?? name}
					value={watch(name)}
					isPunchup={isPunchup}
					onChange={(e) => setValue(name, e.target.value)}
					{...rest}
				/>
			)}
			{description && <InputDescription isPunchup={isPunchup}>{description}</InputDescription>}
			<Error>{error?.message}</Error>
		</InputContainer>
	);
};
